import React from "react";
import { OutputTargetContainer } from "../../../containers";

const OutputTarget = (props) => {
  return <OutputTargetContainer {...props} />;
};

export default OutputTarget;
